import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[nGridDetailTemplate]'
})
export class NGridDetailTemplateDirective {

  constructor(public templateRef: TemplateRef<any>) { }

}
